import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface ICreateScanPayload extends ISagaCb {
    data: {
        scannedCompany: string
        scannedContact: string
    }
}

export interface ICreateScanState {
    status: string
    data: any
    errors: any
}

const initialState: ICreateScanState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const createScan = createSlice({
    name: 'scans/create',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<ICreateScanPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const createScanActions = createScan.actions
export default createScan.reducer
